<script>
  import { onMount } from "svelte";
  let showHint = false;
  const cookieconsent = 'gio_cookieconsent';
  onMount(() => {
    setTimeout(() => {
      showHint = !localStorage.getItem(cookieconsent);
    }, 2500);
    // setTimeout(()=>{
    // if (!localStorage.getItem("cookieconsent")) {
    //   document.body.innerHTML += `<div class="cookieconsent fixed p-4 left-0 bottom-0 bg-main text-white text-center w-full z-50">This site uses cookies. By continuing to use this website, you agree to their use. <a href="#" class="text-white underline">I Understand</a></div>`;
    //   document.querySelector(".cookieconsent a").onclick = function(e) {
    //     e.preventDefault();
    //     document.querySelector(".cookieconsent").style.display = "none";
    //     localStorage.setItem("cookieconsent", true);
    //   };
    // }
    // },2500)
  });

  const click = function() {
    localStorage.setItem(cookieconsent, true);
    showHint = false;
  };
</script>
{#if showHint}
  <div
    class="fixed p-4 left-0 bottom-0 bg-main text-white
    text-center w-full z-50">
    This site uses cookies. By continuing to use this website, you agree to
    their use.
    <a href="/" on:click|preventDefault={click} class="text-white underline">
      I Understand
    </a>
  </div>
{/if}